var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getReportHeaders } from "@adapters/infrastructures/urlConfig/Reports/reportHeaders";
import urlConfig from "@adapters/infrastructures/urlConfig/Reports/reportsUrl";
import { ReportName, ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import { EmailReportParams } from "@domains/dto/Reports/HoldingReport/Request";
import { ILoginAccountTypes } from "@domains/features/LoginFlow/entities/CommonLoginData";
var DownloadReportsRepository = /** @class */ (function () {
    function DownloadReportsRepository(http, file, accountDetails) {
        this.http = http;
        this.file = file;
        this.accountDetails = accountDetails;
    }
    DownloadReportsRepository.prototype.addSearchParams = function (url, searchparams) {
        if (!searchparams)
            return url;
        searchparams.map(function (param) {
            url.searchParams.append(param.key, param.value);
        });
        return url;
    };
    DownloadReportsRepository.prototype.downloadRevampPdfExcel = function (downloadRequestData) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var accountCode, url;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.accountDetails.getAccountCode()];
                    case 1:
                        accountCode = _c.sent();
                        if (!accountCode)
                            return [2 /*return*/];
                        url = new URL(urlConfig[(_a = downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.urlParts) === null || _a === void 0 ? void 0 : _a.firstPart] +
                            ((_b = downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.urlParts) === null || _b === void 0 ? void 0 : _b.secondPart) +
                            "/" +
                            (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.reportType));
                        url = this.addSearchParams(url, downloadRequestData.searchParams);
                        return [4 /*yield*/, this.callDownloadFileApi(url, accountCode, downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.method, downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.requestBody)];
                    case 2: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    DownloadReportsRepository.prototype.emailRevampReport = function (emailRequestData) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function () {
            var accountCode, url;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, this.accountDetails.getAccountCode()];
                    case 1:
                        accountCode = _f.sent();
                        if (!accountCode)
                            return [2 /*return*/];
                        url = new URL(urlConfig[(_a = emailRequestData === null || emailRequestData === void 0 ? void 0 : emailRequestData.urlParts) === null || _a === void 0 ? void 0 : _a.firstPart] +
                            ((_b = emailRequestData === null || emailRequestData === void 0 ? void 0 : emailRequestData.urlParts) === null || _b === void 0 ? void 0 : _b.secondPart) +
                            (((_c = emailRequestData === null || emailRequestData === void 0 ? void 0 : emailRequestData.urlParts) === null || _c === void 0 ? void 0 : _c.thirdPart)
                                ? (_d = emailRequestData === null || emailRequestData === void 0 ? void 0 : emailRequestData.urlParts) === null || _d === void 0 ? void 0 : _d.thirdPart
                                : "/email"));
                        url = this.addSearchParams(url, (_e = emailRequestData === null || emailRequestData === void 0 ? void 0 : emailRequestData.searchParams) !== null && _e !== void 0 ? _e : []);
                        return [4 /*yield*/, this.http
                                .makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: emailRequestData.requestBody,
                                headers: getReportHeaders(accountCode),
                            })
                                .then(function (result) {
                                return result.status;
                            })];
                    case 2: return [2 /*return*/, _f.sent()];
                }
            });
        });
    };
    DownloadReportsRepository.prototype.donwloadPdf = function (downloadRequestData) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var accountCode, url, endPart;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.accountDetails.getAccountCode()];
                    case 1:
                        accountCode = _c.sent();
                        if (accountCode == undefined || accountCode == null || accountCode == "") {
                            return [2 /*return*/, false];
                        }
                        if (downloadRequestData.usetaxDPURL && downloadRequestData.urlParts)
                            url = new URL(urlConfig.dpURL + downloadRequestData.urlParts + "/pdf");
                        else if (!downloadRequestData.usetaxDPURL && downloadRequestData.urlParts)
                            url = new URL(urlConfig.downloadReportUrl +
                                downloadRequestData.reportName +
                                downloadRequestData.urlParts +
                                "/pdf");
                        else if (downloadRequestData.reportName == ReportName.MARGIN)
                            url = new URL(urlConfig.margin + "/pdf");
                        else if (downloadRequestData.reportName === ReportName.SUBSCRIPTION) {
                            url = new URL(urlConfig.subscription + "/pdf");
                            url.searchParams.append("subType", downloadRequestData.subReportName);
                        }
                        else if (downloadRequestData.reportName === ReportName.TRANSACTIONHISTORY)
                            url = new URL(urlConfig.transaction + "/pdf");
                        else if (downloadRequestData.AccType === ILoginAccountTypes.CO)
                            url = new URL(urlConfig.downloadReportCOMUrl + downloadRequestData.reportName + "/pdf");
                        else if (downloadRequestData.reportName === ReportName.DP)
                            url = new URL(urlConfig.dpURL + "/pdf");
                        else if (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.isConsolidated) {
                            endPart = "";
                            if ((_a = downloadRequestData.reportType) === null || _a === void 0 ? void 0 : _a.split("/"))
                                endPart =
                                    ((_b = downloadRequestData.reportType) === null || _b === void 0 ? void 0 : _b.split("/").length) > 1
                                        ? downloadRequestData.reportType.split("/")[1]
                                        : downloadRequestData.reportType.split("/")[0];
                            url = new URL(urlConfig.familyTagging +
                                "/" +
                                downloadRequestData.reportName +
                                "/pdf/" +
                                endPart);
                        }
                        else if (downloadRequestData.reportType === ReportType.PDF_SUMMARY ||
                            downloadRequestData.reportType === ReportType.PDF_DETAIL) {
                            url = new URL(urlConfig.downloadReportUrl +
                                downloadRequestData.reportName +
                                "/pdf/" +
                                downloadRequestData.reportType.split("/")[1]);
                        }
                        else
                            url = new URL(urlConfig.downloadReportUrl + downloadRequestData.reportName + "/pdf");
                        if (downloadRequestData.reportName != ReportName.MARGIN &&
                            downloadRequestData.reportName != ReportName.DP &&
                            !downloadRequestData.usetaxDPURL) {
                            if (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.isConsolidated)
                                url.searchParams.append("accountIds", downloadRequestData.accodes);
                            else
                                url.searchParams.append("accountId", (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.accodes)
                                    ? downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.accodes
                                    : accountCode);
                        }
                        if (downloadRequestData.usetaxDPURL) {
                            url.searchParams.append("accountCode", (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.accodes)
                                ? downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.accodes
                                : accountCode);
                        }
                        if (downloadRequestData.dpId)
                            url.searchParams.append("dpId", downloadRequestData.dpId);
                        if (downloadRequestData.reportName != ReportName.HOLDINGS &&
                            downloadRequestData.reportName != ReportName.SUBSCRIPTION) {
                            url.searchParams.append("fromDate", downloadRequestData.fromDate);
                        }
                        if (downloadRequestData.reportName === ReportName.PNL) {
                            url.searchParams.append("toDate", downloadRequestData.toDate);
                            url.searchParams.append("assetType", typeof downloadRequestData.assetType === "object"
                                ? downloadRequestData.assetType.join(",")
                                : downloadRequestData.assetType);
                        }
                        if (downloadRequestData.reportName === ReportName.TAX ||
                            downloadRequestData.reportName === ReportName.TRANSACTIONHISTORY ||
                            downloadRequestData.reportName === ReportName.LEDGER)
                            url.searchParams.append("toDate", downloadRequestData.toDate);
                        if (downloadRequestData.reportName === ReportName.HOLDINGS)
                            url.searchParams.append("date", downloadRequestData.date);
                        if (downloadRequestData.scripIdentifier)
                            url.searchParams.append("scripIdentifier", downloadRequestData.scripIdentifier.toString());
                        if (downloadRequestData.expiryMonth)
                            url.searchParams.append("expiryMonth", downloadRequestData.expiryMonth.toString());
                        if (downloadRequestData.underlyingAsset)
                            url.searchParams.append("underlyingAsset", downloadRequestData.underlyingAsset.toString());
                        if (downloadRequestData.reportName === ReportName.LEDGER) {
                            if (downloadRequestData.AccType === ILoginAccountTypes.CO)
                                url.searchParams.append("entity", downloadRequestData.entity.toString());
                            else {
                                url.searchParams.append("isMtf", downloadRequestData.isMTF.toString());
                                url.searchParams.append("segment", downloadRequestData.segment.toString());
                            }
                        }
                        if (downloadRequestData.currentValue)
                            url.searchParams.append("currentValue", downloadRequestData.currentValue);
                        if (downloadRequestData.ledgerType)
                            url.searchParams.append("ledgerType", downloadRequestData.ledgerType);
                        if (downloadRequestData.dpType)
                            url.searchParams.append("dpType", downloadRequestData.dpType);
                        return [4 /*yield*/, this.callDownloadFileApi(url, accountCode, downloadRequestData.method, downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.requestBody)];
                    case 2: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    DownloadReportsRepository.prototype.donwloadExel = function (downloadRequestData) {
        return __awaiter(this, void 0, void 0, function () {
            var accountCode, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.accountDetails.getAccountCode()];
                    case 1:
                        accountCode = _a.sent();
                        if (accountCode == undefined || accountCode == null || accountCode == "") {
                            return [2 /*return*/, false];
                        }
                        if (downloadRequestData.usetaxDPURL && downloadRequestData.urlParts)
                            url = new URL(urlConfig.dpURL + downloadRequestData.urlParts + "/excel");
                        else if (!downloadRequestData.usetaxDPURL && downloadRequestData.urlParts)
                            url = new URL(urlConfig.downloadReportUrl +
                                downloadRequestData.reportName +
                                downloadRequestData.urlParts +
                                "/excel");
                        else if (downloadRequestData.reportName == ReportName.MARGIN)
                            url = new URL(urlConfig.margin + "/excel");
                        else if (downloadRequestData.reportName === ReportName.SUBSCRIPTION) {
                            url = new URL(urlConfig.subscription + "/excel");
                            url.searchParams.append("subType", downloadRequestData.subReportName);
                        }
                        else if (downloadRequestData.reportName === ReportName.TRANSACTIONHISTORY)
                            url = new URL(urlConfig.transaction + "/excel");
                        else if (downloadRequestData.AccType === ILoginAccountTypes.CO)
                            url = new URL(urlConfig.downloadReportCOMUrl +
                                downloadRequestData.reportName +
                                "/excel");
                        else if (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.isConsolidated) {
                            url = new URL(urlConfig.familyTagging +
                                "/" +
                                downloadRequestData.reportName +
                                "/excel");
                        }
                        else
                            url = new URL(urlConfig.downloadReportUrl + downloadRequestData.reportName + "/excel");
                        if (!downloadRequestData.usetaxDPURL) {
                            if (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.isConsolidated)
                                url.searchParams.append("accountIds", downloadRequestData.accodes);
                            else
                                url.searchParams.append("accountId", (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.accodes)
                                    ? downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.accodes
                                    : accountCode);
                        }
                        if (downloadRequestData.usetaxDPURL)
                            url.searchParams.append("accountCode", (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.accodes)
                                ? downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.accodes
                                : accountCode);
                        if (downloadRequestData.dpId)
                            url.searchParams.append("dpId", downloadRequestData.dpId);
                        if (downloadRequestData.reportName === ReportName.PNL ||
                            downloadRequestData.reportName === ReportName.PNL_TRANSACTION_REPORT ||
                            downloadRequestData.reportName === ReportName.TAX ||
                            downloadRequestData.reportName === ReportName.TRANSACTIONHISTORY ||
                            downloadRequestData.reportName === ReportName.LEDGER) {
                            url.searchParams.append("fromDate", downloadRequestData.fromDate);
                        }
                        if (downloadRequestData.reportName === ReportName.HOLDINGS) {
                            url.searchParams.append("date", downloadRequestData.date);
                        }
                        if (downloadRequestData.reportName === ReportName.TAX ||
                            downloadRequestData.reportName === ReportName.TRANSACTIONHISTORY ||
                            downloadRequestData.reportName === ReportName.LEDGER)
                            url.searchParams.append("toDate", downloadRequestData.toDate);
                        if (downloadRequestData.reportName === ReportName.PNL ||
                            downloadRequestData.reportName === ReportName.PNL_TRANSACTION_REPORT) {
                            url.searchParams.append("toDate", downloadRequestData.toDate);
                            url.searchParams.append("assetType", typeof downloadRequestData.assetType === "object"
                                ? downloadRequestData.assetType.join(",")
                                : downloadRequestData.assetType);
                        }
                        if (downloadRequestData.currentValue)
                            url.searchParams.append("currentValue", downloadRequestData.currentValue);
                        if (downloadRequestData.scripIdentifier) {
                            url.searchParams.append("scripIdentifier", downloadRequestData.scripIdentifier.toString());
                        }
                        if (downloadRequestData.expiryMonth)
                            url.searchParams.append("expiryMonth", downloadRequestData.expiryMonth.toString());
                        if (downloadRequestData.underlyingAsset)
                            url.searchParams.append("underlyingAsset", downloadRequestData.underlyingAsset.toString());
                        if (downloadRequestData.reportName === ReportName.LEDGER) {
                            if (downloadRequestData.AccType === ILoginAccountTypes.CO)
                                url.searchParams.append("entity", downloadRequestData.entity.toString());
                            else {
                                url.searchParams.append("isMtf", downloadRequestData.isMTF.toString());
                                url.searchParams.append("segment", downloadRequestData.segment.toString());
                            }
                        }
                        if (downloadRequestData.ledgerType)
                            url.searchParams.append("ledgerType", downloadRequestData.ledgerType);
                        if (downloadRequestData.dpType)
                            url.searchParams.append("dpType", downloadRequestData.dpType);
                        return [4 /*yield*/, this.callDownloadFileApi(url, accountCode)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DownloadReportsRepository.prototype.callDownloadFileApi = function (url, accountCode, method, requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http
                            .makeApiCall({
                            method: method ? method : "GET",
                            url: url.toString(),
                            headers: getReportHeaders(accountCode),
                            body: requestPayload,
                        })
                            .then(function (file) {
                            _this.file.saveFile(file);
                            return true;
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DownloadReportsRepository.prototype.emailReport = function (emailData) {
        return __awaiter(this, void 0, void 0, function () {
            var accountCode, isPdf, isExcel, assetType, payload, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.accountDetails.getAccountCode()];
                    case 1:
                        accountCode = _a.sent();
                        if (accountCode == undefined || accountCode == null || accountCode == "") {
                            return [2 /*return*/, false];
                        }
                        isPdf = emailData.reportType == ReportType.PDF ||
                            emailData.reportType == ReportType.PDF_DETAIL ||
                            emailData.reportType == ReportType.PDF_SUMMARY;
                        isExcel = emailData.reportType == ReportType.EXCEL;
                        assetType = typeof emailData.assetType === "object"
                            ? emailData.assetType.join(",")
                            : emailData.assetType;
                        payload = new EmailReportParams((emailData === null || emailData === void 0 ? void 0 : emailData.accodes) ? emailData === null || emailData === void 0 ? void 0 : emailData.accodes : accountCode, emailData.fromDate, emailData.toDate, isPdf, isExcel, emailData.emailIds, assetType, emailData.financialYear, emailData.emailID, emailData.filePath, emailData.subReportName, emailData.scripIdentifier, emailData.dpId, emailData.expiryMonth, emailData.underlyingAsset, emailData.isMTF, emailData.segment, emailData.dpType, emailData.entity, emailData.ledgerType, emailData.currentValue, emailData.reportType === ReportType.PDF_DETAIL, emailData.reportType === ReportType.PDF_SUMMARY);
                        if (emailData.usetaxDPURL && emailData.urlParts)
                            url = new URL(urlConfig.dpURL + emailData.urlParts);
                        else if (!emailData.usetaxDPURL && emailData.urlParts)
                            url = new URL(urlConfig.downloadReportUrl + emailData.reportName + emailData.urlParts);
                        else if (emailData.reportName === ReportName.MARGIN)
                            url = urlConfig.margin;
                        else if (emailData.reportName == ReportName.SUBSCRIPTION)
                            url = urlConfig.subscription;
                        else if (emailData.reportName == ReportName.TRANSACTIONHISTORY)
                            url = urlConfig.transaction;
                        else if (emailData.AccType === ILoginAccountTypes.CO)
                            url = urlConfig.downloadReportCOMUrl + emailData.reportName;
                        else if (emailData === null || emailData === void 0 ? void 0 : emailData.isConsolidated)
                            url = urlConfig.familyTagging + "/" + emailData.reportName;
                        else
                            url = new URL(urlConfig.downloadReportUrl + emailData.reportName);
                        url += "/email";
                        return [4 /*yield*/, this.http
                                .makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: payload,
                                headers: getReportHeaders(accountCode),
                            })
                                .then(function (result) {
                                return result.status;
                            })];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return DownloadReportsRepository;
}());
export { DownloadReportsRepository };
